import React from 'react'
import styled, { css } from 'styled-components'
import ReviewCard from './ReviewCard'
import theme from 'stories/utils/theme'

const Container = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${theme.colors.snowWhite}
    padding-bottom: 50px;
    @media (max-width: 1050px) {
        height: auto;
    }
`

const Grid = styled.div<{ isScrollable?: boolean }>`
    display: flex;
    padding: 25px;
    justify-content: center;
    align-items: end;
    flex-wrap: wrap;
    grid-gap: 15px;
    row-gap: 15px;
    @media (max-width: 1250px) {
        grid-template-columns: 1fr;
    }
    @media (max-width: 750px) {
        ${({ isScrollable }) =>
            isScrollable
                ? css`
                      width: 100%;
                      display: grid;
                      place-content: start;
                      grid-template-columns: 1fr 1fr 1fr;
                      overflow-x: scroll;
                  `
                : ''}
    }
`

interface Props {
    items: {
        text: string
        user: string
    }[]
    isWhiteColor?: boolean
    isScrollable?: boolean
}

const ReviewsSection = ({ items, isWhiteColor, isScrollable }: Props) => {
    return (
        <Container>
            <Grid isScrollable={isScrollable}>
                {items.map(({ text, user }, i) => (
                    <ReviewCard
                        text={text}
                        user={user}
                        key={`information-card-${i}`}
                        isWhiteColor={isWhiteColor}
                        isScrollable={isScrollable}
                    />
                ))}
            </Grid>
        </Container>
    )
}

export default ReviewsSection
